import { Injectable } from '@angular/core';

import { AclConfig, AclControlService } from '@mirage-projects/cw-commons';

export interface AclNode extends AclConfig {
    checked?: boolean;
    allow?: boolean;
    deny?: boolean;
    disabled?: boolean;
}

export type AclTreeItem = {
    label: string;
    nodes: AclNode[];
};

/**
 * Service manages the tree generic permissions list
 */

@Injectable({
    providedIn: 'root',
})
export class TreeViewGenericPermissionsService {
    constructor(private aclControlService: AclControlService) {}

    getAclsTree(): AclTreeItem[] {
        const aclsTreeOrder = [
            'GENERAL_GROUP',
            'USERS_GROUP',
            'GROUPS_GROUP',
            'PERMISSION_MANAGEMENT_GROUP',
            'OBJECT_ACCESS',
            'NOTIFICATION',
        ];

        const aclsTree: AclTreeItem[] = this.aclControlService.aclConfig
            .filter((acl) => acl.group && acl.visible)
            .reduce<AclTreeItem[]>((tree, acl) => {
                const index = aclsTreeOrder.indexOf(acl.group as string);

                tree[index] ??= {
                    label: acl.group as string,
                    nodes: [],
                };

                tree[index].nodes.push(acl);

                return tree;
            }, [] as AclTreeItem[]);
        return aclsTree;
    }
}
